'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodashOmit = require('lodash.omit');

var _lodashOmit2 = _interopRequireDefault(_lodashOmit);

var _tcombReact = require('tcomb-react');

var _browserCookieLite = require('browser-cookie-lite');

var _styleUtils = require('./styleUtils');

var _styleUtils2 = _interopRequireDefault(_styleUtils);

_tcombReact.t['interface'].strict = true;

var Props = {
  children: _tcombReact.t.maybe(_tcombReact.t.union([_tcombReact.t.ReactChildren, _tcombReact.t.Function])),
  message: _tcombReact.t.maybe(_tcombReact.t.String),
  onAccept: _tcombReact.t.maybe(_tcombReact.t.Function),
  link: _tcombReact.t.maybe(_tcombReact.t['interface']({
    msg: _tcombReact.t.maybe(_tcombReact.t.String),
    url: _tcombReact.t.String,
    target: _tcombReact.t.maybe(_tcombReact.t.enums.of(['_blank', '_self', '_parent', '_top', 'framename']))
  })),
  buttonMessage: _tcombReact.t.maybe(_tcombReact.t.String),
  cookie: _tcombReact.t.maybe(_tcombReact.t.String),
  cookieExpiration: _tcombReact.t.maybe(_tcombReact.t.union([_tcombReact.t.Integer, _tcombReact.t['interface']({
    years: _tcombReact.t.maybe(_tcombReact.t.Number),
    days: _tcombReact.t.maybe(_tcombReact.t.Number),
    hours: _tcombReact.t.maybe(_tcombReact.t.Number)
  })])),
  dismissOnScroll: _tcombReact.t.maybe(_tcombReact.t.Boolean),
  dismissOnScrollThreshold: _tcombReact.t.maybe(_tcombReact.t.Number),
  closeIcon: _tcombReact.t.maybe(_tcombReact.t.String),
  disableStyle: _tcombReact.t.maybe(_tcombReact.t.Boolean),
  styles: _tcombReact.t.maybe(_tcombReact.t.Object),
  className: _tcombReact.t.maybe(_tcombReact.t.String)
};

/** React Cookie banner dismissable with just a scroll!
 * @param children - custom component rendered if user has not accepted cookies
 * @param message - message written inside default cookie banner
 * @param onAccept - called when user accepts cookies
 * @param link - object with infos used to render a link to your cookie-policy page
 * @param buttonMessage - message written inside the button of the default cookie banner
 * @param cookie - cookie-key used to save user's decision about you cookie-policy
 * @param cookieExpiration - used to set the cookie expiration
 * @param dismissOnScroll - whether the cookie banner should be dismissed on scroll or not
 * @param dismissOnScrollThreshold -
 *   amount of pixel the user need to scroll to dismiss the cookie banner
 * @param closeIcon - className passed to close-icon
 * @param disableStyle - pass `true` if you want to disable default style
 * @param styles - object with custom styles used to overwrite default ones
 */

var CookieBanner = (function (_React$Component) {
  _inherits(CookieBanner, _React$Component);

  function CookieBanner() {
    var _this = this;

    _classCallCheck(this, _CookieBanner);

    _React$Component.apply(this, arguments);

    this.state = { listeningScroll: false };

    this.addOnScrollListener = function (props) {
      var _props = props || _this.props;
      if (!_this.state.listeningScroll && !_this.hasAcceptedCookies() && _props.dismissOnScroll) {
        if (window.attachEvent) {
          //Internet Explorer
          window.attachEvent('onscroll', _this.onScroll);
        } else if (window.addEventListener) {
          window.addEventListener('scroll', _this.onScroll, false);
        }
        _this.setState({ listeningScroll: true });
      }
    };

    this.removeOnScrollListener = function () {
      if (_this.state.listeningScroll) {
        if (window.detachEvent) {
          //Internet Explorer
          window.detachEvent('onscroll', _this.onScroll);
        } else if (window.removeEventListener) {
          window.removeEventListener('scroll', _this.onScroll, false);
        }
        _this.setState({ listeningScroll: false });
      }
    };

    this.onScroll = function () {
      // tacit agreement buahaha! (evil laugh)
      if (window.pageYOffset > _this.props.dismissOnScrollThreshold) {
        _this.onAccept();
      }
    };

    this.getSecondsSinceExpiration = function (cookieExpiration) {
      if (_tcombReact.t.Integer.is(cookieExpiration)) {
        return cookieExpiration;
      }

      var SECONDS_IN_YEAR = 31536000;
      var SECONDS_IN_DAY = 86400;
      var SECONDS_IN_HOUR = 3600;

      var _cookieExpiration = _extends({
        years: 0, days: 0, hours: 0
      }, cookieExpiration);

      var years = _cookieExpiration.years;
      var days = _cookieExpiration.days;
      var hours = _cookieExpiration.hours;

      return years * SECONDS_IN_YEAR + days * SECONDS_IN_DAY + hours * SECONDS_IN_HOUR;
    };

    this.onAccept = function () {
      var _props2 = _this.props;
      var cookie = _props2.cookie;
      var cookieExpiration = _props2.cookieExpiration;
      var onAccept = _props2.onAccept;

      _browserCookieLite.cookie(cookie, true, _this.getSecondsSinceExpiration(cookieExpiration));
      onAccept({ cookie: cookie });

      if (_this.state.listeningScroll) {
        _this.removeOnScrollListener();
      } else {
        _this.forceUpdate();
      }
    };

    this.getStyle = function (style) {
      var _props3 = _this.props;
      var disableStyle = _props3.disableStyle;
      var styles = _props3.styles;

      if (!disableStyle) {
        // apply custom styles if available
        return _extends({}, _styleUtils2['default'].getStyle(style), styles[style]);
      }
    };

    this.getCloseButton = function () {
      var _props4 = _this.props;
      var closeIcon = _props4.closeIcon;
      var buttonMessage = _props4.buttonMessage;

      if (closeIcon) {
        return _react2['default'].createElement('i', { className: closeIcon, onClick: _this.onAccept, style: _this.getStyle('icon') });
      }
      return _react2['default'].createElement(
        'div',
        { className: 'button-close', onClick: _this.onAccept, style: _this.getStyle('button') },
        buttonMessage
      );
    };

    this.getLink = function () {
      var link = _this.props.link;

      if (link) {
        return _react2['default'].createElement(
          'a',
          {
            href: link.url,
            target: link.target,
            className: 'cookie-link',
            style: _this.getStyle('link')
          },
          link.msg || 'Learn more'
        );
      }
    };

    this.getBanner = function () {
      var _props5 = _this.props;
      var children = _props5.children;
      var className = _props5.className;
      var message = _props5.message;

      if (children) {
        if (_tcombReact.t.Function.is(children)) {
          return children(_this.onAccept);
        }
        return children;
      }

      var props = _lodashOmit2['default'](_this.props, Object.keys(Props));
      var computedClassName = _classnames2['default']('react-cookie-banner', className);
      return _react2['default'].createElement(
        'div',
        _extends({}, props, { className: computedClassName, style: _this.getStyle('banner') }),
        _react2['default'].createElement(
          'span',
          { className: 'cookie-message', style: _this.getStyle('message') },
          message,
          _this.getLink()
        ),
        _this.getCloseButton()
      );
    };

    this.hasAcceptedCookies = function () {
      return typeof window !== 'undefined' && _browserCookieLite.cookie(_this.props.cookie);
    };
  }

  CookieBanner.prototype.componentDidMount = function componentDidMount() {
    this.addOnScrollListener();
  };

  CookieBanner.prototype.render = function render() {
    return this.hasAcceptedCookies() ? null : this.getBanner();
  };

  CookieBanner.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.dismissOnScroll) {
      this.addOnScrollListener(nextProps);
    } else {
      this.removeOnScrollListener();
    }
  };

  CookieBanner.prototype.componentWillUnmount = function componentWillUnmount() {
    this.removeOnScrollListener();
  };

  _createClass(CookieBanner, null, [{
    key: 'defaultProps',
    value: {
      onAccept: function onAccept() {},
      dismissOnScroll: true,
      cookie: 'accepts-cookies',
      cookieExpiration: { years: 1 },
      buttonMessage: 'Got it',
      dismissOnScrollThreshold: 0,
      styles: {}
    },
    enumerable: true
  }]);

  var _CookieBanner = CookieBanner;
  CookieBanner = _tcombReact.props(Props, { strict: false })(CookieBanner) || CookieBanner;
  return CookieBanner;
})(_react2['default'].Component);

exports['default'] = CookieBanner;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-cookie-banner/lib/CookieBanner.js
// module id = 292
// module chunks = 0